<agr-page-toolbar [pageTitle]="pageTitle$ | async" [hasPrimaryAction]="false" class="milk-delivery">
  <div class="wrapper--spacing-all">
    <div class="flex--justify-space-between spacing--margin-bottom">
      <h5 class="text--h5">{{ 'dairyresults.milk-delivery-month-summary.header' | translate }}</h5>
      <app-month-picker (dateChanged)="onDateChanged($event)"></app-month-picker>
    </div>

    <div class="spacing--margin-bottom table-desktop">
      @if (hasData()) {
        <table
          mat-table
          #table
          [dataSource]="dataSource"
          class="table-desktop__table--alternate-rows cust-table"
        >
          @for (column of columnIds(); track column; let colIndex = $index) {
            <ng-container matColumnDef="{{ column }}">
              <th mat-header-cell *matHeaderCellDef>
                @if (columns[colIndex].subLabel) {
                  <div>
                    <div
                      class="flex--column"
                      [class]="{ 'text--right': allignRight(columns[colIndex].type) }"
                    >
                      <div>
                        {{ columns[colIndex].label | translate }}
                      </div>
                      <div>
                        {{ columns[colIndex].subLabel | translate }}
                      </div>
                    </div>
                  </div>
                }
                @if (!columns[colIndex].subLabel) {
                  <div
                    [class]="{
                      'text--right': allignRight(columns[colIndex].type),
                    }"
                  >
                    {{ columns[colIndex].label | translate }}
                  </div>
                }
              </th>
              <td
                mat-cell
                *matCellDef="let row"
                [class]="{
                  'mat-column-number': colIndex > 0,
                }"
              >
                @if (columns[colIndex].type === 'number') {
                  <div>
                    {{ row[column] | number: columns[colIndex].format }}
                  </div>
                }
                @if (columns[colIndex].type === 'money') {
                  <div>
                    {{ row[column] | currency: 'EUR' }}
                  </div>
                }
                @if (columns[colIndex].type === 'period') {
                  <div>
                    {{ 'common.format.month-' + row['month'] | translate }} ({{ row['year'] }})
                  </div>
                }
              </td>
              <td
                mat-footer-cell
                *matFooterCellDef="let row"
                class="mat-column-number"
                [class]="{
                  'mat-column-number': colIndex > 0,
                }"
              >
                @if (columns[colIndex].type === 'number' && footer) {
                  <div>
                    {{ footer[column] | number: columns[colIndex].format }}
                  </div>
                }
                @if (columns[colIndex].type === 'money' && footer) {
                  <div>
                    {{ footer[column] | currency: 'EUR' }}
                  </div>
                }
                @if (columns[colIndex].type === 'period') {
                  <div>Totaal</div>
                }
              </td>
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="columnIds()"></tr>
          <tr mat-row *matRowDef="let row; columns: columnIds()"></tr>
          <tr mat-footer-row *matFooterRowDef="columnIds()"></tr>
        </table>
      }
    </div>
    <agr-notification-empty
      [isEmpty]="!hasData()"
      [emptyTitle]="'no_items' | translate"
      emptyImage="/assets/images/no-items.png"
      class="complete__notification-empty"
    >
    </agr-notification-empty></div
></agr-page-toolbar>
